import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";

import NotFound from "@/views/404";

import { publicRoutes } from "@/router/publicRoutes";
import ProtectedRoute from "@/router/protectedRoutesComponent";
import PublicRoute from "@/router/publicRoutesComponent";
import ErrorPage from "@/views/error";
import RoleBasedRoute from "@/router/roleBasedRoute";

import {
  HOProtectedRoutes,
  SAProtectedRoutes,
  MainSailAdminProtectedRoutes,
} from "./protectedRoutes";

// Create a single stable router that includes all routes
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="" errorElement={<ErrorPage />}>
      <Route path="" element={<PublicRoute />}>
        {publicRoutes.map((route) => (
          <Route
            path={route.path}
            key={route.key}
            element={<route.component />}
          />
        ))}
      </Route>
      <Route path="" element={<ProtectedRoute />}>
        {/* Include all routes - access control happens in RoleBasedRoute */}
        {[
          ...HOProtectedRoutes,
          ...SAProtectedRoutes,
          ...MainSailAdminProtectedRoutes,
        ]
          .filter(
            (route, index, arr) =>
              // Remove duplicates by path
              arr.findIndex((r) => r.path === route.path) === index
          )
          .map((route) => (
            <Route
              path={route.path}
              key={route.key}
              element={
                <RoleBasedRoute>
                  <route.component />
                </RoleBasedRoute>
              }
            />
          ))}
      </Route>
      <Route path="*" element={<NotFound />} />
    </Route>
  )
);

export default router;
